/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// $(document).ready(function(){
//   $('.cart-recap__checkout[type="submit"][name="checkout"]').attr('disabled', true);
//   $('body').delegate('.fineTuneOptions-termsCheckbox[type="checkbox"]', 'change', function(){
//     if($(this).is(':checked')){
//        console.log('checked');
//        $('.cart-recap__checkout[type="submit"][name="checkout"]').attr('disabled', false);
//     } else {
//     	console.log('not checked');
//        	$('.cart-recap__checkout[type="submit"][name="checkout"]').attr('disabled', true);
//     }
//   })
  
//       console.log('worked')    	

//   $('body.watchrapport-cart-otp-veri-support').delegate('button.cart-recap__checkout[type="submit"][name="checkout"]', 'click', function(e){
//     e.stopPropagation();
//     e.preventDefault();
//     console.log('worked')    	
//   })
//   $('body').delegate('button.cart-recap__checkout', 'click', function(e){
// 	      console.log('worked');
//     	if ($('body').hasClass('watchrapport-cart-otp-veri-support')) {
// 	      e.stopPropagation();
// 	      e.preventDefault();
// 	      console.log('worked');
//     	}
//     });
// });
// 



// CD

$(document).on("click",".tabs_title",function(){
  if($(this).hasClass("change_icon")){
    $(this).removeClass("change_icon");
   $(this).parent().find(".panel").slideUp();
  }else{
    $(".tabs_title").removeClass("change_icon");
    $(".tabs_title").parent().find(".panel").slideUp();
    $(this).addClass("change_icon");
  	$(this).parent().find(".panel").slideDown();
  }
});


// CD CODE
$(window).scroll(function(){
  var scroll = $(window).scrollTop();
  var anno_height = 0;
  if($('#cb-announement-bar').length){
    anno_height = $('#cb-announement-bar').height();
  }
  if($('.promo_bar.active').length) {
    anno_height = anno_height+$('.promo_bar.active').outerHeight();
  }
  
  if (scroll >= 150){ 
    // $('.header.header-new-design').addClass('header_sticky');
    $('#shopify-section-header_design').css('top', anno_height+'px');
  }else{ 
    // $('.header.header-new-design').removeClass('header_sticky');
    $('#shopify-section-header_design').css('top', 0);
  }
});

$(document).on('click', '.custom-sell-menu', function(){
  if($(this).hasClass('show-custom-menus')){
    $(this).removeClass('show-custom-menus');
  }else{
    $(this).addClass('show-custom-menus');
  }
});

$(document).on("click", function(e) {
  if(!$('.custom_menus .menu_list').has(e.target).length || $(e.target).is(".custom_menus .menu_list .sub-menu")){
    $('.custom-sell-menu').removeClass('show-custom-menus');
  }
});

$(document).on('click', '.header_main-menu_list .first-level > a', function(e){
  e.preventDefault();
  $('.header_main-menu_list > ul').addClass('show-menu-list');
  
  if($(this).parent().hasClass('sub_menu-show')){
    $('.triger-search-btn').removeClass('open-search-text');
    $(this).parent().removeClass('sub_menu-show');
  }else{
    $('.header_main-menu_list .first-level').removeClass('sub_menu-show');
    $('.triger-search-btn').addClass('open-search-text');
    $(this).parent().addClass('sub_menu-show');
  }
});

$(document).on('click', '.triger-search-btn', function(e){
  //$(this).addClass('open-search-text');
  if($(this).hasClass('open-search-text')){
    var $form = $('.search_form');
    var search_val = $form.find('.search_input').val().trim();
    if(search_val != '') {
      $form.find('.search_input').removeAttr('name');
      $form.append('<input type="hidden" name="q" value="'+search_val+'">');
      $form.submit();
    } else {
      $('.first-level:first-child a').trigger("click");  
    }
  } else {
    $('.first-level:first-child a').trigger("click");
  }
});

$(document).on("click", function(e) {
  if(!$('.header_main-menu_list > ul').has(e.target).length || $(e.target).is(".menu_list")){
    $('.header_main-menu_list > ul').removeClass('show-menu-list');
    $('.header_main-menu_list .first-level').removeClass('sub_menu-show');
    $('.triger-search-btn').removeClass('open-search-text');
  }
});

// CD CODE
// $(document).on('click', '.permission label', function(e){
//   setTimeout(function(){ 
//     if($('#terms_and_conditions').is(':checked') == true && $('.permission input').is(':checked') == true){
//       $('.template-cart #submit_button').attr('disabled', false);
//     } else{
//       $('.template-cart #submit_button').attr('disabled', true);
//     }
//   }, 100);
// });

$(document).on('click', '#terms_and_conditions', function(e){
  setTimeout(function(){ 
    if($('#terms_and_conditions').is(':checked') == true){
      $('.template-cart #submit_button').attr('disabled', false);
    } else{
      $('.template-cart #submit_button').attr('disabled', true);
    }
  }, 100);
});

$(document).on('click', '.js-cart_popup-open', function(e){
  e.preventDefault();
  $('.cart_popup').addClass('show_popup');
});
$(document).on('click', '.cart_popup .close_icon', function(e){
  $('.cart_popup').removeClass('show_popup');
});

$(document).on("click", function(e) {
  if(!$('.cart_popup .cart-wrapper').has(e.target).length && !$(e.target).is(".js-cart_popup-open")){
    $('.cart_popup').removeClass('show_popup');
  }
});

$(document).on('click','.lnk_checkout',function(e){
  e.preventDefault();
  var $scroll_elem = $('.scroll_to_chkout');
  var scroll_to = null;
  if($scroll_elem.length) scroll_to = $scroll_elem.offset().top;
  if($(window).width() < 1000) {
    $scroll_elem = $('#submit_button');
    if($scroll_elem) {
      scroll_to = $scroll_elem.offset().top - 50;
    } else {
      scroll_to = null;
    }
  }
  if(scroll_to != null) $('html,body').animate({scrollTop: scroll_to});
});

$(document).ready(function(){
  if($('.promo_bar').length) {
    $('.promo_bar').addClass('active');
    $(':root').get(0).style.setProperty('--promo-height',$('.promo_bar').outerHeight()+'px');
    $('.header-new-design').removeClass('pt-header');
  }

  $('.promo_close').on('click',function(){
    $('.promo_bar').removeClass('active');
    $(':root').get(0).style.setProperty('--promo-height',0);
    $('.header-new-design').removeClass('pt-header');
  });

  // CD Sanket
  // if($('.elfsight-app-16c5014a-5377-45da-878c-8a8b12928ea4').length){
  //   $(':root').get(0).style.setProperty('--promo-height-top',$('.elfsight-app-16c5014a-5377-45da-878c-8a8b12928ea4').outerHeight()+'px');
  // }
  
  if($('.top_bar_slider .text-slide').length) {
    $('.top_bar_slider').flickity({
      autoPlay: true,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      cellSelector: '.text-slide',
      pageDots: false,
      fade: true
    });
  }
  
  if($('.desc-html').length) {
    var title,html = '',lbl_html = '',value;
    $('.desc-html h6').each(function(){
      title = $(this).text().toLowerCase();
      if(title == 'condition' || title == 'scope of delivery') {
        html += '<div class="tab _tab">';
        html += '<div class="tab-title">';
        html += $(this)[0].outerHTML;
        html += '<span class="down-arrow" data-uw-styling-context="true"><svg class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="presentation" data-uw-styling-context="true"><path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square" data-uw-styling-context="true"></path></svg></span>';
        html += '</div>';
        html += '<div class="tab-body">';
        html += $(this).next()[0].outerHTML;
        html += '</div>';
        html += '</div>';
        
        if(title == 'condition') {
          lbl_html += '<span class="product-label condn-label">';
          lbl_html +=  $(this)[0].innerText+' <a href="#condn" class="lbl-cta cta_popup">('+$(this).next()[0].innerText.split('(')[0].trim()+')</a>';
          lbl_html +=  '</span>';
        } else {
          lbl_html += '<span class="product-label scope-label">';
          lbl_html +=  $(this).next()[0].innerText;
          lbl_html +=  '</span>';
        }
      }
    });
    $('.desc-html table tr').each(function(){
      title = $(this).find('td:eq(0)').text().toLowerCase();
      value = $(this).find('td:eq(1)').text().toLowerCase();
      if(title == 'year of production' && value != 'unknown') {
        lbl_html += '<span class="product-label year-label">';
        lbl_html +=  'Year of production '+$(this).find('td:eq(1)').text();
        lbl_html +=  '</span>';
      }
    });
    $('.product-tabs').html(html);
    $('.product_labels').append(lbl_html);
  }
});

$(document).on('click','.cta_popup',function(e){
  e.preventDefault();
  $('body').addClass('open-popup');
  $($(this).attr('href')).removeClass('hide').siblings('.popup-content').addClass('hide');
  
//   CD
  if($(this).attr('href') == '#askquestion'){
    if($("#askquestion").find(".alert--success").length){
      $(".alert--success").addClass("hide");
    }
  }
  
  if($('.cancel_button').length){
    var order_number = $(this).parents('.flits-order-card').find('.flits-order-information .flits-order-information-row div:first-child .flits-order-number').text();
    $('#order_id').val(order_number)
    $('#order_number_show').text(order_number)
  }
  
    if($('.cancel_button').length){
    var order_total_price = $(this).parents('.flits-order-card').find('.flits-grand-total .flits-strong .money').text();
    $('#order_total_price').text(order_total_price)
  }
  
  if($('.cancel_button').length){
    var total_product = '';
    $.each($(this).parents('.flits-order-card').find('.flits-order-item'), function(key,val) {
      var data_sku = $(this).attr('data-sku')
      var product_title = $(this).find('.flits-product-name').text();
      total_product += product_title + "-" + data_sku + " , ";
    });
    $('#order_title_sku').val(total_product)
  }
  
    if($('.cancel_button').length){
    var order_detail = $(this).parents('.flits-order-card').find('.flits-line-items').html();
    $('#order_img_title').html(order_detail)
  }
  
});

$(document).on('click','.btn_inquiry',function(){
  $('body').addClass('open-popup');
  $('#askquestion').removeClass('hide').siblings('.popup-content').addClass('hide');
});

$('.popup_close').on('click',function(){
  $('body').removeClass('open-popup');
});

$('.popup').on('click',function(e){
  if(!$(e.target).is('.popup-inner') && $('.popup-inner').has(e.target).length === 0) {
    $('body').removeClass('open-popup');
  }
});

$('.collapse_tab').on('click',function(){
  $(this).toggleClass('active');
  $(this).find('.collapse-content').slideToggle();
  $(this).siblings('.collapse_tab').removeClass('active');
  $(this).siblings('.collapse_tab').find('.collapse-content').slideUp();
});

$('.btn_menu').on('click',function(){
  $(this).parents('.customer-menu-wrap').find('.customer-menu').toggleClass('active');
});

$(document).on('click',function(e){
  if(!$(e.target).is('.btn_menu') && $('.btn_menu').has(e.target).length === 0) {
    if(!$(e.target).is('.customer-menu') && $('.customer-menu').has(e.target).length === 0) {
      $('.customer-menu').removeClass('active');
    }
  }
  
  if(!$(e.target).is('.search_toggle') && $('.search_toggle').has(e.target).length === 0) {
    if(!$(e.target).is('.search-drawer') && $('.search-drawer').has(e.target).length === 0) {
      $('.search-drawer').removeClass('active');
    }
  }
});

$('.search_toggle').on('click',function(e){
  e.preventDefault();
  var $parent = $(this).parents('.search-wrap');
  if($parent.find('.search-drawer').hasClass('active')) {
    var $form = $parent.find('.m_search_form');
    var search_val = $parent.find('.m_search_input').val().trim();
    if(search_val != '') {
      $form.find('.m_search_input').removeAttr('name');
      $form.append('<input type="hidden" name="q" value="'+search_val+'">');
      $form.submit();
    } else {
      $parent.find('.search-drawer').removeClass('active');
    }
  } else {
    $parent.find('.search-drawer').addClass('active');
  }
});

$('.btn_protn_cancel').on('click',function(){
  $('body').removeClass('open-protection');
  $('.product-form .add_btn').removeAttr('disabled');
});

$('.btn_protn_activate').on('click',function(){
  $('body').removeClass('open-protection');
  $('.product-form .add_btn').removeAttr('disabled');
  $('.product-form .add_btn').trigger('click');
});

$(document).on('click','._tab',function(){
  $(this).toggleClass('active');
  $(this).find('.tab-body').slideToggle();
  $(this).siblings('._tab').removeClass('active');
  $(this).siblings('._tab').find('.tab-body').slideUp();
});

$(document).ready(function(){
  $(document).on('mousedown','.product-form .add_btn',function(e){

    $(this).attr('disabled', 'disabled');
    e.preventDefault();
    $('body').addClass('open-protection');
  });
  
  if($('.delivery_date').length) {
    var days = parseInt($('.delivery_date').attr('data'));
    var today = new Date();
    var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    today.setDate(today.getDate() + days);
    var result_date = months[today.getMonth()]+' '+String(today.getDate()).padStart(2,'0')+', '+today.getFullYear();
    $('.delivery_date').text(result_date);
    $('[data-delivery]').val(result_date);
  }

  if($('.js_arrival_date').length) {
    var days = parseInt($('.delivery_date').attr('data'));
    var today = new Date();
    var prev_date = new Date();
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    today.setDate(today.getDate() + days);
    prev_date.setDate(prev_date.getDate() + days - 5);
    
    var result_date = months[today.getMonth()]+' '+String(today.getDate()).padStart(2,'0');
    var prev_result_date = months[prev_date.getMonth()]+' '+String(prev_date.getDate()).padStart(2,'0');
    $('.js_startdate').text(prev_result_date);
    $('.js_enddate').text(result_date);
  }
  
  $('.que_icon').on('click',function(){
    $(this).parents('.que-popover').find('.q-popover').addClass('active');
  });
  $('.q_close').on('click',function(){
    $(this).parents('.que-popover').find('.q-popover').removeClass('active');
  });
});

// CD
function calculate_top_spacing() {
  if($('.below-header').length) {
    if($('.header-new-design').length) {
      // var header_height = Math.min($('.header-new-design').outerHeight(), 78)+26;
      var header_height = Math.min($('.header-new-design').outerHeight(), 50);
      if($('.header_main-menu_list').length) header_height = header_height + $('.header_main-menu_list').outerHeight();
      $('.below-header').get(0).style.setProperty("--top-spacing", header_height+'px');
    }
  }
}

// CD
$(document).ready(function(){
  if($(".template-product").length){
    if (window.location.href.indexOf('?contact_posted=true#contact_form') > 0 || window.location.href.indexOf('?contact_posted=true') > 0) {
      var uri = window.location.toString();
      if (uri.indexOf("?") > 0) {
        var clean_uri = uri.substring(0, uri.indexOf("?"));
        window.history.replaceState({}, document.title, clean_uri);
        $("body").addClass("open-popup");
        $(".popup-inner#askquestion").removeClass('hide').siblings('.popup-content').addClass('hide');
      }
    }
  }
  
  $('.call_to_add').on('click',function(){
    // cd code (Skip Protection Popup)
    // if($('.trigger_add').hasClass('add_btn')) {
    //   $('.trigger_add').trigger('mousedown');
    // } else {
    //   $('.trigger_add').trigger('click');
    // }
    $('.trigger_add').trigger('click');
  });
  
  calculate_top_spacing();
  $(window).on('resize',function(){
    calculate_top_spacing();
  });
});

// cd code
if($(window).width() < 1000){
  if($('.custom_announce_text .custom_announce_text_content').length) {
    $('.custom_announce_text .custom_announce_text_content').flickity({
      prevNextButtons: false,
      pageDots: true,
      autoPlay: true
    });
  }
}

$( document ).ready(function() {
  if($(window).width() > 999){
    $('.affim_section').css("opacity", "1");
    $('.custom_announce_text .custom_announce_text_hide_show').css("display", "block");
  }
});

// CD CODE
$(document).ready(function(){
  if($('.category_product_section .category_slider').length) {
    $('.category_product_section .category_slider').flickity({
      cellAlign: 'left',
      contain: true,
      groupCells: true,
      dots: false
    });
  }
});

// cd code
$(document).on("click", ".custom_back_to_top", function() {
  $("html").animate({ scrollTop: 0 }, "slow");
});

$('.tabs_wrap_toggle').on('click',function(){
  $(this).toggleClass('active');
  $(this).parents('.tabs_wrap').find('.tabs_outer').slideToggle();
});

$(document).on("click",".js_whatsapp_trigger",function(e){
  e.preventDefault();
  $(".wa__btn_popup").trigger("click");
});

$(document).ready(function(){
  if($(".template-customers").length){
    if (window.location.href.indexOf('?checkout_url=') > 0) {
      var checkout_url = window.location.toString().split("?checkout_url=");
      var url_decode = decodeURIComponent(checkout_url[1])

      let query_params = url_decode.split('?')[1],params;
      query_params = query_params.split('&');

      query_params = query_params.filter((query_param) => {
        params = query_param.split('=');
        return (params[0] == 'discount');
      });
            
      if($(".template-login").length){
        $("#customer_login").append("<input type='hidden' name='return_to' value='"+url_decode+"'>");
        $(".customer_pages_header a.account-link").attr("href","/account/register?checkout_url="+url_decode);
        $(".form__secondary-action .desktop_height a").attr("href","/account/register?checkout_url="+checkout_url[1]);
      } 
      if($(".template-register").length){
        //$(".customer_register_page #create_customer").append("<input type='hidden' name='checkout_url' value='"+url_decode+"'>");
        //$(".customer_register_page #create_customer").append("<input type='hidden' name='return_to' value='"+url_decode+"'>");
        $(".customer_register_page #create_customer").append("<input type='hidden' name='return_to' value='/checkout?"+query_params[0]+"'>");
        
        $(".customer_pages_header a.account-link").attr("href","/account/login?checkout_url="+url_decode);
        $(".form__secondary-action a").attr("href","/account/login?checkout_url="+url_decode);
      } 
    }
  }
});

// CD Sanket
$(document).ready(function(){
});
  
$(document).on('click','.menu-item-grid', function() {
  var first_aria = $(this).find('.menu-item-icon');
  var second_aria = $(this).find('.menu-item-grid-body');

  if(first_aria.hasClass('icon-style')){
    first_aria.removeClass('icon-style');
    $(this).find('.menu-item-icon svg:first-child').addClass('icon-style-hide');
     $(this).find('.menu-item-icon svg:last-child').removeClass('icon-style-hide');
      second_aria.slideToggle();   
  }else{
    first_aria.addClass('icon-style');
    $(this).find('.menu-item-icon svg:last-child').addClass('icon-style-hide');
    $(this).find('.menu-item-icon svg:first-child').removeClass('icon-style-hide');
     second_aria.slideToggle();
  }
});

// $(document).on('click',".js_price_score",function(){
//   $(".price_score_details").css("display","none");
//   $(this).parents(".price_score").find(".price_score_details").css("display","block");
// });
$(document).on('click',".js_price_close",function(){
  $(this).parents(".price_score_details").css("display","none");
});

// $(document).ready(function(){
//   if($('.js_pro_button_text').length){
//     $('.js_pro_button_text').removeAttr('disabled');
//     $('.js_pro_button_text').text("Buy Now");
//   }
// });

$(document).ready(function(){
  if($('.pro_disable_class').length){
    var $tag = $('.pro_disable_class').attr('data_tag');
    window.location.href = "https://watchrapport.com/search?type=product&q="+ $tag +"*";
  }
});